import React from 'react';
import { RadioGroup } from './radio-group';
import { defaultSortOption, sortOptions } from './sort-options';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesSearchSortingMobile = _ref => {
  var _ref$listingType = _ref.listingType,
    listingType = _ref$listingType === void 0 ? 'SALES_RESIDENTIAL' : _ref$listingType,
    _ref$searchType = _ref.searchType,
    searchType = _ref$searchType === void 0 ? 'normal' : _ref$searchType,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultSortOption : _ref$value,
    _ref$onSelect = _ref.onSelect,
    onSelect = _ref$onSelect === void 0 ? () => {} : _ref$onSelect;
  return ___EmotionJSX(RadioGroup, {
    options: sortOptions({
      listingType,
      searchType
    }),
    currentValue: value,
    onChange: onSelect
  });
};